import styled, { css } from 'styled-components/macro'

import { fluidSystem } from 'styled'

export const Root = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  pointer-events: ${({ visited }) => (visited ? 'none' : 'all')};
`

export const Options = styled.div`
  ${fluidSystem};
  flex: 0 999 100%;
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
`

export const ListButton = styled.div`
  ${({ leaving, entering, nth, navDirection }) => css`
    opacity: ${leaving || entering ? 0 : 1};
    transform: translate(${(leaving ? -50 : entering ? 50 : 0) * navDirection}%, 0);
    transition: all 0.3s ${nth * 0.05 + navDirection * (leaving ? 0 : 0)}s;
  `};

  text-align: center;

  ${({ wrapped }) =>
    wrapped
      ? css`
          flex: 1 0 auto;
          width: 40%;
          &:nth-child(odd) {
            margin-right: 16px;
          }
        `
      : css`
          flex: 0 0 auto;
          width: 100%;
        `};

  &:not(:last-child) {
    margin-bottom: 8px;
  }
`
